import { z } from "zod";
export const getEmailSchema = (t) => z.object({
    email: z
        .string({ invalid_type_error: t("contact.form.email_error_empty") })
        .min(1, { message: t("contact.form.email_error_empty") })
        .email({ message: t("contact.form.email_error_invalid") }),
});
